import { ENotificationBadgeSize, NotificationBadge } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Link from '@/components/switchback/Link/Link';
import { isMessagesMenuItem, useMyAccountMenuItems } from '@/constants/menu';
import { trackNavClickedEvent } from '@/services/analytics/header';

interface IProps {
  hasPendingReviews?: boolean;
  isOwner?: boolean;
  userName?: string;
  unreadConversations?: number;
  onClickSignout: () => void;
  onClickItem?: () => void;
  isAutoPage?: boolean;
}

const GlobalHeaderNavMyAccount: React.FC<IProps> = ({
  // hasPendingReviews,
  isOwner,
  userName,
  unreadConversations,
  onClickSignout,
  onClickItem,
  isAutoPage = false,
}) => {
  const intl = useIntl();
  const items = useMyAccountMenuItems(isAutoPage);
  const linkClassName = 'flex items-center py-3 text-gray-800 autoType300 w-full';

  const handleOnClick = (link: string) => {
    trackNavClickedEvent({
      clickedLink: link,
      isInDropdown: true,
      dropdownHeader: 'My Account',
    });
  };

  return (
    <div className="lg:min-w-[16rem]">
      <div className="pb-6 mb-3 font-bold text-gray-900 border-b border-gray-310 lg:pt-0 autoType500">
        {userName ? (
          <FormattedMessage
            defaultMessage="Hi, {name}"
            id="IjcYm5"
            description="Global Header > My Account"
            values={{ name: userName }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="Hi"
            id="Sd5efi"
            description="Global Header > My Account"
          />
        )}
      </div>

      <ul>
        {items.map((item, index) => {
          const isMessages = isMessagesMenuItem(item);
          // const isUpcomingTrips = item.href === '/trips';

          const hasNotifications = isMessages && !!unreadConversations;

          return (
            <li key={index}>
              <Link legacy href={item.href}>
                <a
                  className={linkClassName}
                  onClick={() => {
                    onClickItem?.();
                    handleOnClick(item.label);
                  }}>
                  {item.label}
                  {hasNotifications && (
                    <span className="flex pl-2 [&>div]:bg-green-500">
                      <NotificationBadge
                        ariaLabel={intl.formatMessage({
                          defaultMessage: 'Unread messages',
                          id: 'pUjlgQ',
                        })}
                        count={unreadConversations}
                        size={ENotificationBadgeSize.Small}
                      />
                    </span>
                  )}
                </a>
              </Link>
            </li>
          );
        })}

        <li className="pt-4 mt-4 border-t border-gray-310">
          {isOwner ? (
            <a
              href="/dashboard"
              className={linkClassName}
              onClick={() => {
                onClickItem?.();
                handleOnClick('Dashboard');
              }}>
              <FormattedMessage
                defaultMessage="Switch to hosting"
                id="2dLHvx"
                description="Global Header > My Account"
              />
            </a>
          ) : (
            <a
              href={isAutoPage ? '/become-a-host/auto' : '/become-a-host'}
              className={linkClassName}
              onClick={() => {
                onClickItem?.();
                handleOnClick(isAutoPage ? 'List my Car' : 'List my RV');
              }}>
              {isAutoPage ? (
                <FormattedMessage
                  defaultMessage="List your Auto"
                  id="8rj/ag"
                  description="Global Header > My Account"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="Become a host"
                  id="1Cch+Q"
                  description="Global Header > My Account"
                />
              )}
            </a>
          )}
        </li>

        <li>
          <button
            type="button"
            className={linkClassName}
            onClick={() => {
              handleOnClick('Log out');
              onClickSignout();
            }}>
            <FormattedMessage
              defaultMessage="Log out"
              id="Xne/lE"
              description="Global Header > My Account"
            />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default GlobalHeaderNavMyAccount;
